export default function RefundPage() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-10">
      <h1 className="text-2xl font-bold mb-6">Politique de remboursement</h1>

      <p className="mb-4">
        Aucun remboursement n’est proposé après souscription.
      </p>

      <p className="mb-4">
        Exception : un remboursement peut être accordé en cas de bug majeur empêchant totalement l’utilisation du service.
      </p>

      <p className="mb-4">
        Contact : contact@tonsite.com
      </p>
    </div>
  );
}
